import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const tutorPreferenceApi = createApi({
  reducerPath: 'tutorPreferenceApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Preferences'],
  endpoints: (builder) => ({
    getPreferences: builder.query({
      query: () => ({
        url: `/WebTutor/GetTutorNotificationPreference`,
        method: "Get",
      }),
    }),
    updatePreferences: builder.mutation({
      query: (credentials) => ({
        url: `/WebTutor/UpdatePreferences`,
        method: "POST",
        body: {preferences: credentials.preferences},
      }),
    }),
  }),
});

export const { 
  useGetPreferencesQuery,
  useUpdatePreferencesMutation
} = tutorPreferenceApi;